import React from "react";
import "./Songs.scss";
import SongCube from "../../SongCube/SongCube";
import data from "../../../static/data/data.json";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "../../../stores/application.store";
import {shuffle} from "../../../services/data";
const Songs = () => {
  const { setSongsCubeShowing, songsCubeShowing } = useContext(AppContext);
  let songs;



  useEffect(() => {

    //Sets the Observer options
    const options = {
      root: null, // The view port
      threshhold: 0.5, // 0 ~ 1
      rootMargin: "0px", // like margin in css
    };
    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        let songId = parseInt(entry.target.id.replace("image-", ""));
        if (songsCubeShowing.includes(songId)) return;

        let cubesShowing = songsCubeShowing;
        cubesShowing.push(songId);
        setSongsCubeShowing([...songsCubeShowing, songId]);
      });
    }, options);
    const wantedNodes = document.querySelectorAll(".song-image");
    wantedNodes.forEach((li) => {
      observer.observe(li);
    });

  }, []);
  const items = data.Songs.slice(0, 10);
  return (
    <div>
      <div className="songs-text">
        <span>בחרו מהרשימה עד עשרה שירים שהכי אהבתם השנה,</span>
        <span className="purple">יש לבחור לפחות חמישה שירים</span>
      </div>
      <div className="songs-page">
        {data.Songs.map((song) => (
          <SongCube key={song.ID} song={song} />
        ))}
      </div>
      {/* <Footer/> */}
    </div>
  );
};

export default Songs;
